<template>
  <div
    v-bind:class="[$parent.isBreakpoint('xs') ? 'pl-5 pr-5' : '', $parent.isBreakpoint('sm') ? 'pl-3 pr-3' : '', $parent.isBreakpointMin('md') ? 'pl-1 pr-1' : '']">
    <v-card color="black" class="rond white--text" v-bind:class="$parent.blueBorder"
      :hover="connected && !heatingInProgress && ready && mode != '2' && mode != '3'"
      v-on="connected && !heatingInProgress && ready && mode != '2' && mode != '3' ? { click: () => editDialog = true } : {}">
      <!-- Widget ventil -->
      <v-responsive :aspect-ratio="1 / 1">
        <v-card-text>
          <div class="white--text paco_typo" v-bind:class="$parent.fontSize">
            <template v-if="mode == '2'">{{ humidity }} %</template>
            <template v-else>&nbsp;</template>
          </div>

          <div v-bind:class="$parent.isSmall ? 'mt-1 mb-1' : 'mt-2 mb-2'">
            <div class="main_value_container paco_typo" v-bind:class="$parent.fontSize">{{ ventilation }}</div>
          </div>
          <div v-bind:class="$parent.isSmall ? 'mt-2' : 'mt-5'">
            <v-icon color="white" :small="$parent.isSmall" :large="$parent.isLarge">icon-ventil</v-icon>
          </div>
        </v-card-text>
      </v-responsive>

      <!-- Dialogue d'édition -->
      <v-dialog v-model="editDialog" persistent max-width="320px" @keydown.esc="cancel()">
        <v-card>
          <v-alert v-model="alert" dismissible type="error">{{ alertMessage }}</v-alert>
          <v-card-text v-if="!loading">
            <v-btn-toggle v-model="ventilationEdit" mandatory style="width:100%">
              <v-btn block flat large :value="'0'">0</v-btn>
              <v-btn block flat large :value="'1'">1</v-btn>
              <!-- <v-btn block flat large :value="'2'">2</v-btn> -->
            </v-btn-toggle>
          </v-card-text>
          <v-card-text v-else class="text-xs-center">
            <v-progress-circular color="primary" indeterminate></v-progress-circular>
          </v-card-text>
          <v-card-actions>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-btn color="black" flat large block @click="cancel()" :disabled="loading">{{
                  $t('global.cancel')
                }}</v-btn>
              </v-flex>
              <v-flex xs12 sm6>
                <v-btn color="green darken-1" flat large block @click="save()"
                  :disabled="loading || this.ventilationEdit == this.ventilation">{{ $t('global.save') }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    editDialog: false,
    ventilationEdit: null,
    alert: false,
    alertMessage: null
  }),
  computed: {
    connected() {
      return this.$store.state.connected;
    },
    ovenData() {
      return this.$store.state.ovenData;
    },
    // four (1) ou desidratateur (2)
    mode() {
      return this.ovenData.mode;
    },
    working() {
      return this.ovenData.working;
    },
    // chauffe en cours (boolean)
    heatingInProgress() {
      if (this.working == "1") {
        return true;
      }
      return false;
    },
    // en veille ou non
    state() {
      return this.ovenData.state;
    },
    // veillle ou non (boolean)
    ready() {
      if (this.state == "1") {
        return true;
      } else {
        return false;
      }
    },
    ventilation() {
      return this.ovenData.ventilation;
    },
    humidity() {
      return this.ovenData.humidity;
    }
  },
  watch: {
    ventilation() {
      this.ventilationEdit = this.ventilation;
    }
  },
  methods: {
    reset() {
      this.alert = false;
      this.alertMessage = null;
    },
    // annule
    cancel() {
      if (!this.loading) {
        this.editDialog = false;
        // reset la valeur d'édition
        this.ventilationEdit = this.ventilation;
        // reset
        this.alert = false;
        this.alertMessage = null;
      }
    },
    // enregistre
    save() {
      // sécu
      if (this.ventilationEdit == this.ventilation) {
        return;
      }

      // loading
      this.loading = true;
      // requette
      this.$store
        .dispatch("pushVentilation", this.ventilationEdit)
        .then(res => {
          this.$store.commit("setVentilation", this.ventilationEdit);
          this.loading = false;
          // ferme la dialog
          this.editDialog = false;
          //
          this.reset();
        })
        .catch(err => {
          this.alert = true;
          this.alertMessage = this.$t("global.connexionError");
          this.loading = false;
        });
    }
  },
  mounted() {
    if (this.ventilation) {
      this.ventilationEdit = this.ventilation;
    }
  }
};
</script>

<style>
.v-btn--active {
  background-color: "red";
}
</style>
